import { ScrollTrigger } from "gsap/ScrollTrigger";

const Reviews = () => {
	const block = document.querySelectorAll(".reviews");
	if (!block) {
		return;
	}
	const scrollTriggerRefresh = () => {
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 200);
	};

	block.forEach((el) => {
		const panels = el.querySelectorAll(".review-panel [data-toggle-target]");
		const items = el.querySelectorAll(".reviews__list-item");
		const footer = el.querySelector(".reviews__footer");
		const moreControl = el.querySelector(".reviews__footer .custom-link");
		const itemsCount = 5;
		let itemsToShow = itemsCount;

		moreControl.addEventListener("click", (e) => {
			itemsToShow = itemsToShow + itemsCount;

			items.forEach((item, index) => {
				if (index < itemsToShow && !item.classList.contains("active")) {
					item.classList.add("active");
				}
			});

			if (itemsToShow >= items.length) {
				footer.classList.add("reviews__footer_hide")
			}

			scrollTriggerRefresh();
		});

		panels.forEach((panel) => {
			panel.addEventListener("toggleAfter", event => {
				scrollTriggerRefresh();
			});
		});
	});
};

export default Reviews;
